//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Define Mapbox style
const MAPBOX_STYLE = 'mapbox://styles/bizonweb/cl45g0ktw000314qswetvr90d';

export default {
    name: 'BowMap',

    props: {
        center: {
            default: () => ({
                lat: 45.6107313,
                lng: 10.5512431,
            }),
            type: Object,
        },
        height: {
            default: 'h-full',
            type: String,
        },
        htmlTag: {
            default: null,
            type: String,
        },
        locations: {
            default: () => [],
            type: Array,
        },
        width: {
            default: 'w-full',
            type: String,
        },
        zoom: {
            default: 12,
            type: Number,
        },
    },

    data: () => ({
        currentCenter: [10.5512431, 45.6107313],
        currentZoom: 12,
        list: [],
        mapStyle: MAPBOX_STYLE,
        markers: [],
        popup: {
            index: null,
            image: null,
            link: null,
            title: null,
            subtitle: null,
        },
        showPopup: false,
    }),

    computed: {
        getToken() {
            return this.$store.state.map.mapboxKey;
        },

        isValidMap() {
            if (this.currentCenter && this.currentZoom) {
                return true;
            }

            return false;
        },

        places() {
            const list = [];

            if (this.locations && this.locations.length > 0) {
                this.locations.forEach((item) => {
                    const { card } = item;

                    if (card.coordinates) {
                        if (
                            card.coordinates.lat &&
                            card.coordinates.lat !== '' &&
                            card.coordinates.lng &&
                            card.coordinates.lng !== ''
                        ) {
                            list.push({
                                ...card,
                            });
                        }
                    }
                });
            }

            this.updateList(list);

            return list;
        },
    },

    created() {
        this.currentCenter = [this.center.lng, this.center.lat];
        this.currentZoom = this.zoom;
    },

    methods: {
        handleMarkerClick(e) {
            const markers = [...this.$refs.markers];

            if (markers && markers.length > 0) {
                markers.forEach((item) => {
                    const marker = item.$children.filter((el) => {
                        return el.$options._componentTag === 'MglMarker';
                    });

                    if (marker) {
                        marker[0].marker._element.classList.remove('is-active');
                    }
                });
            }

            const item = Number(e.marker._element.getAttribute('data-item'));
            const newCenter = [];

            if (item !== null && typeof item !== 'undefined') {
                const location = this.list[item];

                if (location) {
                    this.popup.index = item;

                    this.popup.image = null;
                    if (
                        Object.prototype.hasOwnProperty.call(location, 'image')
                    ) {
                        this.popup.image = location.image
                            ? location.image
                            : null;
                    }

                    this.popup.title = null;
                    if (
                        Object.prototype.hasOwnProperty.call(
                            location,
                            'pretitle'
                        ) &&
                        Object.prototype.hasOwnProperty.call(location, 'title')
                    ) {
                        if (location.pretitle && location.title) {
                            this.popup.title = `${this.$t(location.pretitle)} ${
                                location.title
                            }`;
                        }
                    }

                    if (
                        Object.prototype.hasOwnProperty.call(
                            location,
                            'customTitle'
                        )
                    ) {
                        if (
                            location.customTitle &&
                            location.customTitle !== ''
                        ) {
                            this.popup.title = location.customTitle;
                        }
                    }

                    const serviziToPrint = [];

                    if (
                        Object.prototype.hasOwnProperty.call(
                            location,
                            'servizi'
                        )
                    ) {
                        if (location.servizi) {
                            if (
                                Object.prototype.hasOwnProperty.call(
                                    location.servizi,
                                    'ospiti'
                                )
                            ) {
                                if (
                                    location.servizi.ospiti &&
                                    location.servizi.ospiti !== ''
                                ) {
                                    serviziToPrint.push(
                                        `${location.servizi.ospiti} ${this.$t(
                                            'ospiti'
                                        )}`
                                    );
                                }
                            }

                            if (
                                Object.prototype.hasOwnProperty.call(
                                    location.servizi,
                                    'camere'
                                )
                            ) {
                                if (
                                    location.servizi.camere &&
                                    location.servizi.camere !== ''
                                ) {
                                    serviziToPrint.push(
                                        `${location.servizi.camere} ${this.$t(
                                            location.servizi.camere === '1'
                                                ? 'camera'
                                                : 'camere'
                                        )}`
                                    );
                                }
                            }

                            if (
                                Object.prototype.hasOwnProperty.call(
                                    location.servizi,
                                    'bagni'
                                )
                            ) {
                                if (
                                    location.servizi.bagni &&
                                    location.servizi.bagni !== ''
                                ) {
                                    serviziToPrint.push(
                                        `${location.servizi.bagni} ${this.$t(
                                            location.servizi.bagni === '1'
                                                ? 'bagno'
                                                : 'bagni'
                                        )}`
                                    );
                                }
                            }
                        }
                    }

                    this.popup.subtitle =
                        serviziToPrint.length > 0
                            ? String(serviziToPrint.toString('')).replaceAll(
                                ',',
                                ', '
                            )
                            : null;

                    if (
                        Object.prototype.hasOwnProperty.call(
                            location,
                            'customSubtitle'
                        )
                    ) {
                        if (
                            location.customSubtitle &&
                            location.customSubtitle !== ''
                        ) {
                            this.popup.subtitle = location.customSubtitle;
                        }
                    }

                    this.popup.link = null;
                    if (
                        Object.prototype.hasOwnProperty.call(location, 'link')
                    ) {
                        if (location.link && location.link !== '') {
                            this.popup.link = location.link;
                        }
                    }

                    if (
                        Object.prototype.hasOwnProperty.call(
                            location,
                            'coordinates'
                        )
                    ) {
                        if (
                            location.coordinates.lng &&
                            location.coordinates.lng !== '' &&
                            location.coordinates.lat &&
                            location.coordinates.lat !== ''
                        ) {
                            newCenter.push(location.coordinates.lng);
                            newCenter.push(location.coordinates.lat);
                        }
                    }
                }
            }

            if (this.popup.title !== null) {
                const marker = e.marker._element;
                marker.classList.add('is-active');

                this.showPopup = this.popup.title !== null;
            }

            if (newCenter.length === 2) {
                return newCenter;
            }

            return null;
        },

        /**
         * @param {Array} list
         *
         * @returns {void}
         */
        updateList(list) {
            this.showPopup = false;

            const markers = this.$refs.markers ? [...this.$refs.markers] : [];
            if (markers) {
                markers.forEach((item) => {
                    const marker = item.$children.filter((el) => {
                        return el.$options._componentTag === 'MglMarker';
                    });

                    if (marker) {
                        marker[0].marker._element.classList.remove('is-active');
                    }
                });
            }

            if (list && list.length > 0) {
                this.list = [...list];
            }
        },
    },
};
